import { Component } from '@angular/core';
import { ContentBlock } from '@insolution/core-ui';
import { OpenConsultsWidget, PatientsWidget } from '@insolution/dashboard-feature';

@Component({
  selector: 'lib-dashboard-page',
  imports: [ContentBlock, PatientsWidget, OpenConsultsWidget],
  templateUrl: './dashboard-page.html',
  styleUrl: './dashboard-page.scss',
})
export class DashboardPage {}
